export default __webpack_public_path__ + "static/media/robot.41b5ae49.png";